import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionElement } from "models";

export const useEditSubitemsMutation = () =>
  useTypedMutation({
    mutationFn: async (element: InterventionElement) => (await ApiInstance.post("/interventions/element/update", element)).data,
    onSuccess: element => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const matchingInterventionIdx = appointment.interventions.findIndex(intervention => intervention.elements?.some(el => el.id === element.id));
      if (matchingInterventionIdx < 0) return;

      const matchingIntervention = appointment.interventions[matchingInterventionIdx];
      const matchingElementIdx = matchingIntervention.elements?.findIndex(el => el.id === element.id) ?? -1;
      if (matchingElementIdx < 0) return;

      const matchingElement = matchingIntervention.elements?.at(matchingElementIdx);
      if (!matchingElement) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(matchingInterventionIdx, {
          ...matchingIntervention,
          elements: matchingIntervention.elements?.with(matchingElementIdx, { ...matchingElement, ...element })
        })
      });
    }
  });
